import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import { styled, Switch, SwitchProps } from '@mui/material';

type StyledSwitchProps = SwitchProps & {
  switchLabel: string;
};

const SwitchTsoPq = styled(Switch, {
  shouldForwardProp: (prop) => !['switchLabel'].includes(prop as string),
})<StyledSwitchProps>(({ switchLabel }) => ({
  width: '2.75rem',
  height: '1.75rem',
  padding: 0,
  display: 'flex',
  alignItems: 'center',

  '& .MuiSwitch-switchBase': {
    padding: '0.25rem',
    top: '50%',
    transform: 'translateY(-50%)',

    '&.Mui-checked': {
      transform: 'translateY(-50%) translateX(1rem)',
      color: tsoPqTheme.palette.customTextColor.color_font_ft_white,

      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim_enabled,
      },
    },
  },

  '& .MuiSwitch-thumb': {
    height: '1.25rem',
    width: '1.25rem',
  },

  '& .MuiSwitch-track': {
    backgroundColor: tsoPqTheme.palette.background.neutral.color_neutral_background_bg_ntrl_dark,
    borderRadius: '1rem',
    height: '1.75rem',
    width: '2.75rem',
    opacity: 1,
  },
}));
export default SwitchTsoPq;
